module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_9006.6e392b61.png";